import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  logoIcon: {
    position: "fixed",
    zIndex: theme.zIndex.dialog + 1,
    margin: 0,
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    top: 30,
    left: -theme.spacing.space12,
    display: "none",
    "&.open": {
      display: "flex",
    },
  },
}));
